import styled from "@emotion/styled";
import React from "react";
import { getStylingState } from "../../textinput/styled/formInputTheme";
import { textAreaTheme } from "../textAreaTheme";
export const StyledResizerBase = styled("div")(_ref => {
  let {
    themeMode,
    isFocused,
    focusMode,
    validationState
  } = _ref;
  return `
    color: ${textAreaTheme.resizerColor(themeMode)};
    position: absolute;
    bottom: ${textAreaTheme.resizerOffset.bottom[getStylingState({
    validationState,
    isFocused,
    focusMode
  })](themeMode)};
    right: ${textAreaTheme.resizerOffset.right[getStylingState({
    validationState,
    isFocused,
    focusMode
  })](themeMode)};
    z-index: 1;

    // necessary to keep the resizer sizing consistent even
    // if overriding styles are provided
    font-size: 13px;
    line-height: 18px;

    &:hover {
        cursor: ns-resize;
    }
`;
});
export const StyledResizer = props => {
  return /*#__PURE__*/React.createElement(StyledResizerBase, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "8",
    height: "8",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.655 1.053a.5.5 0 1 0-.707-.707L.346 6.948a.5.5 0 1 0 .707.707l6.602-6.602Zm0 3.772a.5.5 0 0 0-.708-.707l-2.83 2.829a.5.5 0 0 0 .708.707l2.83-2.83Z",
    clipRule: "evenodd"
  })));
};
//# sourceMappingURL=StyledResizer.js.map